import { StorageBox } from "Models/storage.box";

export const getStorageBoxName = (
  storageBox: Pick<StorageBox, "number" | "id" | "storageBoxType">
) => {
  const fullText = `${storageBox.storageBoxType?.name} #${storageBox.number}`;

  return {
    fullText,
  };
};
